import { Button, InputGroup, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useState } from "react";
import css from "./ScenarioRerunTitle.module.scss";

export const ScenarioRerunTitle: React.FC<{
    // The scenario being duplicated
    originalTitle: string;
    value: string;
    disabled: boolean;
    onChange: (value: string) => void;
}> = ({ originalTitle, value, disabled, onChange }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [draft, setDraft] = useState(value);
    const isDraftBlank = draft.trim() === "";

    const commit = () => {
        if (isDraftBlank) {
            return;
        }
        onChange(draft.trim());
        setIsEditing(false);
    };

    return (
        <div className={css["ScenarioRerunTitle"]}>
            {isEditing ? (
                <>
                    <InputGroup
                        className={css["ScenarioRerunTitle-input"]}
                        value={draft}
                        autoFocus
                        disabled={disabled}
                        aria-label={`New name for ${originalTitle}`}
                        onValueChange={setDraft}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                commit();
                            } else if (event.key === "Escape") {
                                setIsEditing(false);
                            }
                        }}
                    />
                    <Button
                        icon={IconNames.CROSS}
                        variant="minimal"
                        aria-label="Discard rename"
                        onClick={() => setIsEditing(false)}
                    />
                    <Button
                        icon={IconNames.TICK}
                        intent={Intent.PRIMARY}
                        disabled={isDraftBlank}
                        aria-label="Save name"
                        onClick={commit}
                    />
                </>
            ) : (
                <>
                    <span className={css["ScenarioRerunTitle-name"]}>
                        {value}
                    </span>
                    <Button
                        icon={IconNames.EDIT}
                        variant="minimal"
                        disabled={disabled}
                        aria-label={`Rename the duplicate of ${originalTitle}`}
                        onClick={() => {
                            setDraft(value);
                            setIsEditing(true);
                        }}
                    />
                </>
            )}
        </div>
    );
};
